// removed by extract-text-webpack-plugin
module.exports = {"header":"_10WZGpPu63YmdlJmBfsUUF","title":"_3JqwPIKwM0hNDz6o5_RWbI","intro":"_1MZswiL3sgvUvm9U4W4SgA"};


//////////////////
// WEBPACK FOOTER
// ./src/Header.css
// module id = 31
// module chunks = 0